import type { ChatEvent } from "@hopper-ai/chat-provider";

/**
 * Whether a provider event means the startup loading surface should come down.
 *
 * The assistant's first message is the happy path. A failed or dropped
 * connection also clears it, so a session that never starts shows the chat
 * rather than an indefinite loading state.
 */
export const clearsInitialLoading = (event: ChatEvent): boolean => {
  if (event.type === "message_start") {
    return true;
  }

  return (
    event.type === "connection_status_changed" &&
    (event.status === "failed" || event.status === "disconnected")
  );
};
